var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.rowClass},[(_vm.selected)?_c('div',{staticClass:"absolute w-5px pin-t pin-b left-0bg-blue"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }